export default __webpack_public_path__ + "static/media/lynnGame3.8979be7f.png";